<template>
  <AppDialog
    :disable-confirm-button="isStringEmpty(name)"
    :loading-confirm-button="isLoading"
    :show="show"
    :title="$t('dashboard.duplicate_module')"
    class="dcd-Modal"
    hide-hero
    @on-close="onClose"
    @on-confirm="onConfirm"
  >
    <template #confirm-btn-text>
      {{ $t('dropdown.copy') }}
    </template>
    <div class="dcd-ContentWrapper">
      <FormFieldNext :label="$t('dashboard.module_name')">
        <AppInput
          ref="inputName"
          v-model="name"
          :max-length="CUSTOM_DASHBOARD_NAME_MAX_LENGTH"
          :placeholder="$t('dashboard.module_name_placeholder')"
          size="xlg"
          style-type="primary"
        />
      </FormFieldNext>
    </div>
  </AppDialog>
</template>

<script setup>
import { nextTick, ref, useTemplateRef, watch } from 'vue'

import CustomDashboardApiHandler from '@/api/custom-dashboard'
import { CUSTOM_DASHBOARD_NAME_MAX_LENGTH } from '@/utils/custom-dashboard-helper'
import { handleError } from '@/utils/error-handling'
import { isStringEmpty } from '@/utils/general'

import AppDialog from '@/components/AppDialog'
import FormFieldNext from '@/components/form/FormFieldNext'
import AppInput from '@/components/ui/AppInput/AppInput'

defineOptions({
  name: 'DuplicateCustomDashboardModule'
})

const props = defineProps({
  show: {
    type: Boolean
  },

  dashboardToDuplicate: {
    type: Object,
    required: true
  },

  modelValue: {
    type: Object,
    default: () => ({})
  }
})
const emit = defineEmits(['update:show', 'confirm'])

const input = useTemplateRef('inputName')

const name = ref('')
const onClose = () => {
  emit('update:show', false)
}

watch(
  () => props.show,
  value => {
    if (!value) {
      name.value = ''
    } else {
      nextTick(() => {
        input.value.focus()
      })
    }
  }
)

const isLoading = ref(false)
const onConfirm = async () => {
  try {
    isLoading.value = true
    const customDashboardApi = new CustomDashboardApiHandler()
    const { id } = props.dashboardToDuplicate

    const data = await customDashboardApi.duplicateDashboardModule({
      dashboardId: id,
      newName: name.value,
      moduleId: props.modelValue.id
    })

    onClose()
    emit('confirm', data)
  } catch (error) {
    handleError({ error })
  } finally {
    isLoading.value = false
  }
}
</script>

<style lang="scss" scoped>
.dcd-ContentWrapper {
  display: flex;
  flex-direction: column;
  gap: 24px;
}
</style>
